// icon:location-pin | Fontawesome https://fontawesome.com/ | Fontawesome
import * as React from "react";

function IconLocationPin(props) {
  return (
    <svg
      viewBox="0 0 384 512"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M384 192c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192z" />
    </svg>
  );
}

export default IconLocationPin;
